import { inject, InjectionToken } from '@angular/core';
import { RemoteConfigService } from '../services';
import { RemoteConfigValueType } from '../enums';

export interface RemoteConfigProvider {
  readonly fetchAndActivate: () => Promise<boolean>;
  readonly getValue: <T>(key: string, type: RemoteConfigValueType, defaultValue: T) => Promise<T>;
}

export const REMOTE_CONFIG_TOKEN: InjectionToken<RemoteConfigProvider> = new InjectionToken<RemoteConfigProvider>(
  'REMOTE_CONFIG_TOKEN',
  {
    factory: (): RemoteConfigProvider => {
      const remoteConfigService: RemoteConfigService = inject(RemoteConfigService);

      return {
        fetchAndActivate(): Promise<boolean> {
          return remoteConfigService.fetchAndActivate();
        },
        getValue<T>(key: string, type: RemoteConfigValueType, defaultValue: T): Promise<T> {
          return remoteConfigService.getValue(key, type, defaultValue);
        }
      };
    }
  }
);
